import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M10 17l5-5-5-5v10z" />, 'ArrowRight');
